export default "__VITE_ASSET__ChlFgJkX__"